export const shipmentType = {
  carrier: 'Voie postale',
  courier: 'Coursier Sympl'
};

export const currentState = {
  created: 'Créé',
  shipment_received:
    "Colis retour reçu à l'entrepôt, en attente de vérification du contenu",
  processing_paused: "Colis retour reçu à l'entrepôt, contenu non conforme",
  processed: 'Traité',
  cancelled: 'Annulé'
};
